export default __webpack_public_path__ + "static/media/wallet-new.04599969.png";